module.exports = __webpack_public_path__ + "img/161-Gris Anthracite Mat.jpg";